module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_6005.0a9b8360.png";